import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from './http-gateway.service';
import { ApplicationStore, ApplicationStoreType } from '../store/application.store';

const CLIENT_LOGGING_URLS = {
    LOG_ERROR: 'client-logging/v5',
};

@Injectable({ providedIn: 'root' })
export class ClientLoggingService {
    private httpGateway = inject(HttpGatewayService);
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    public log(correlationId: string, error: any) {
        const user = this.applicationStore.signedInUser();
        const body = {
            correlationId: correlationId,
            userName: user?.username,
            location: window.location.href,
            error: { message: error.message, stack: error.stack },
        };

        this.httpGateway.post(CLIENT_LOGGING_URLS.LOG_ERROR, body).subscribe({ error: () => {} });
    }
}
